import React from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const RatnaRenewalDate = () => {
  const { userDetails } = useSelector((state: any) => state.user);

  const renewalDate = userDetails.subscriptionRenewsOn;
  const nextFreeCreditRatnaAt = userDetails.nextFreeCreditRatnaAt
    ? new Date(userDetails.nextFreeCreditRatnaAt * 1000)
    : null;
  const ratnaCount = userDetails?.plan?.ratnaCount;
  const ratnaBalance = userDetails?.balance;
  const hasRatnaReachedLimit = ratnaCount * 0.2 > ratnaBalance;

  const showRenewalDate = renewalDate && ratnaCount && ratnaBalance && hasRatnaReachedLimit;

  if (showRenewalDate || nextFreeCreditRatnaAt) {
    return (
      <span className="ratna-renewal-data-tag">
        Renews on {dayjs(nextFreeCreditRatnaAt || renewalDate).format('DD MMMM, YYYY')}
      </span>
    );
  }

  return <></>;
};

export default RatnaRenewalDate;
